// extracted by mini-css-extract-plugin
export default {"empty":"RatingStars_empty__lC1uh","fill":"RatingStars_fill__Kq5pr"};